module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/tags/tag.component.scss
// module id = ./src/app/tags/tag.component.scss
// module chunks = main